import { useMutation } from 'react-query';
import { LoanOfficers } from '~/api/scheme';
import { isEmpty } from 'lodash';
import { OnSyncSuccessCallback } from '~/components/agents/types';
import { useSnackbar } from 'notistack';
import { SyncParams } from '~/api/scheme/loan_officers/sync';

type Args = {
  listType: ListSTI;
  onSyncSuccess?: OnSyncSuccessCallback;
};

type Result = {
  syncAgents: (ids: string[]) => void;
  syncSingleAgent: (id: string) => void;
};

const useSync = (args: Args): Result => {
  const { onSyncSuccess, listType } = args;
  const { enqueueSnackbar } = useSnackbar();

  // ? How does it work for realtors if we use LoanOfficers.sync for agents as well
  const mutation = useMutation((params: SyncParams) => LoanOfficers.sync(params), {
    onSuccess(response) {
      if (isEmpty(response.data.error)) {
        onSyncSuccess?.(response.data.data);
      } else {
        // changeWarningsState('syncLo', true);
        if (response.data.error.includes('already in list')) {
          enqueueSnackbar(response.data.error, { variant: 'info' });
        } else {
          enqueueSnackbar('Something went wrong', { variant: 'error' });
        }
      }
    },
    onError() {
      // changeWarningsState('syncLo', true);
      enqueueSnackbar('Something went wrong', { variant: 'error' });
    },
  });

  // TODO: rework entities ids all over the app
  const syncAgents = (ids: string[]) => {
    mutation.mutate({ ids: ids, type: listType });
  };

  const syncSingleAgent = (id: string) => {
    mutation.mutate({ ids: [id], type: listType });
  };

  return {
    syncAgents,
    syncSingleAgent,
  };
};

export default useSync;
